module.exports = __webpack_public_path__ + "static/media/31.bd4af781.png";